import React from 'react';
import NewCard from "./NewCard";
import { v4 as uuidv4 } from 'uuid';
import {useSelector} from "react-redux";
import {Animate} from "react-simple-animate";

export default function NPreview() {

    const { watches } = useSelector((state) => state.watches)
    const { reads } = useSelector((state) => state.reads)
    const { learns } = useSelector((state) => state.learns)

    const latestWatch = [...watches].sort((a, b) =>{
        return b.date - a.date
    })[0]

    const latestRead = [...reads].sort((a, b) =>{
        return b.date - a.date
    })[0]

    const latestLearn = [...learns].sort((a, b) =>{
        return b.date - a.date
    })[0]

    const sortOrder = ["videos", "post", "tutorials"]

    const sortByObject = sortOrder
        .reduce((obj, item, index) => {
            return {
                ...obj,
                [item]: index,
            };
        }, {});


    const sortedCards = [latestLearn, latestWatch, latestRead].sort((a, b) => sortByObject[a.type] - sortByObject[b.type]);

    return (
        <div className="flex flex-wrap npreview h-full bg-purple-slumber rounded-lg overflow-y-scroll">

            {sortedCards && sortedCards.map((card) =>
                <Animate play start={{opacity: 0}} end={{opacity: 1}} duration={0.7} key={uuidv4()}>
                    <NewCard
                        imgSrc={card?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? null}
                        date={card?.date ?? null}
                        authorName={card?.type === "post" ? card?._embedded?.author?.[0]?.name ?? "" : ""}
                        title={card?.title?.rendered ?? ""}
                        type={card?.type ?? null}
                        text={card?.content?.rendered ?? ""}
                        vidLink={card?.acf?.video_network === "vimeo" ? card?.acf?.vimeo_url ?? null : card?.acf?.youtube_url ?? null}
                        mediaType={card?.type ?? null}
                        mediaId={card?.id ?? null}
                        orientation={card?.acf?.orientation ?? null}
                    />
                </Animate>
            )}

        </div>
    );
}
